import type { FetchResponse } from 'ofetch'
import { ExceptionApiGeneral } from '~/data/exceptions/ExceptionApiGeneral'
import { ExceptionApiNotFound } from '~/data/exceptions/ExceptionApiNotFound'
import { ExceptionApiAccessTokenExpired } from '~/data/exceptions/ExceptionApiAccessTokenExpired'

const genertateApiExceptionByStatusCode = (
  statusCode: number,
  message: string,
) => {
  switch (statusCode) {
    case EXCEPTION_STATUS_CODE.UNAUTHORIZED:
      return new ExceptionApiAccessTokenExpired()
    case EXCEPTION_STATUS_CODE.BAD_REQUEST:
      // todo refresh token expired관련 처리?
      return new ExceptionApiGeneral(message)
    case EXCEPTION_STATUS_CODE.NOT_FOUND:
      return new ExceptionApiNotFound(message)
    case EXCEPTION_STATUS_CODE.FORBIDDEN:
    default:
      return new ExceptionApiGeneral(message)
  }
}

export const generateApiException = (response?: FetchResponse<any>) => {
  if (!response) {
    return new ExceptionApiGeneral()
  }

  const statusCode = response._data.fail?.status ?? response.status
  const message =
    response._data.fail?.message ??
    response._data.error?.message ??
    response.statusText

  return genertateApiExceptionByStatusCode(statusCode, message)
}
